import { TargetModelAfCCCSettings } from 'data/target/target.types';
import { TARGET_INFO_TYPE } from '../target-info-defs';
import { errorMessages, getMessage } from '../util';

// eslint-disable-next-line import/prefer-default-export
export function isVerintStarGateTargetInfoSupported(
  accessFunction?: {tag?: string, x3TargetAssociations?: string },
): boolean {
  if (accessFunction == null) {
    return false;
  }

  return ((accessFunction.tag === 'VRNT_SG' || accessFunction.tag === 'COGNYTE') && accessFunction.x3TargetAssociations === TARGET_INFO_TYPE.VRNTSGWT);
}

export function isVerintStarGateTargetInfoValid(
  accessFunctionSettings: TargetModelAfCCCSettings[],
  targetType: string,
  errors: string[],
  errorMsgPrefix: string | null,
): boolean {
  if (targetType === 'CASEID') {
    return true;
  }

  if (accessFunctionSettings.length === 0) {
    errors.push(getMessage(errorMessages.REQUIRED_TARGET, errorMsgPrefix, targetType));
    return false;
  }

  const isValid = accessFunctionSettings.every(({ options }) => {
    const hasTerritory = options.find(({ key }) => key === 'TERRID') != null;
    const hasMonitoringCenter = options.find(({ key }) => key === 'MCID') != null;

    return hasTerritory && hasMonitoringCenter;
  });

  if (!isValid) {
    errors.push(getMessage(errorMessages.REQUIRED_TARGET, errorMsgPrefix, targetType));
  }

  return isValid;
}
